module.exports = __webpack_public_path__ + "img/dario-dominguez.0c91e951.png";